/* 2 Nov (Claude): SIZE CHART BUTTON for pet products whose size table has a "Typical breeds" column (harnesses, collars, jackets). pdp-premium.js skips those because it expects a Vitals size chart; where no Vitals chart shows up, this adds the same "Size chart" button next to the size buttons, opening a pop-up with the table (breed examples included, wrapped so they can be read without scrolling). Also makes every theme-made "Size chart" button a solid claret button with white text so it is easy to spot. Undo: remove the sww-breed-sizechart line in snippets/meta-tags.liquid. */
(function () {
  'use strict';
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  var RULER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><rect x="2" y="7" width="20" height="10" rx="1.5"/><path d="M6 7v4M10 7v3M14 7v4M18 7v3"/></svg>';

  /* easy-to-spot button look for every theme-made Size chart button (claret with white text, like the rest of the site) */
  function linkStyle() {
    if (document.getElementById('sww-sc-link-style')) return;
    var s = document.createElement('style');
    s.id = 'sww-sc-link-style';
    s.textContent = '.sww-sc-link{background:#5e2634 !important;color:#ffffff !important;border:0 !important;border-radius:999px !important;padding:7px 16px !important;font-size:14px !important;font-weight:600 !important;text-decoration:none !important;letter-spacing:.2px;line-height:1.2;cursor:pointer}.sww-sc-link span{color:#ffffff !important;text-decoration:none !important}.sww-sc-link svg{stroke:#ffffff !important;color:#ffffff !important}.sww-sc-link:hover{background:#7a3a4d !important}';
    document.head.appendChild(s);
  }
  try { linkStyle(); } catch (e) {}

  function vitalsShowing(info) {
    return [].slice.call(info.querySelectorAll('[class*="vtl"] *, [class*="vitals"] *')).some(function (e) {
      if (e.closest('.product__description, .sww-sc-link, .sww-sc-dialog, .sww-acc')) return false;
      return e.children.length === 0 && /^\s*size\s*(chart|guide)s?\s*$/i.test(e.textContent || '') && e.getBoundingClientRect().height > 0;
    });
  }

  function build() {
    var info = document.querySelector('.product__info');
    if (!info) return;
    var fs = [].slice.call(info.querySelectorAll('.product__option')).filter(function (f) {
      var l = f.querySelector('.product__option-label');
      return l && /^\s*sizes?\b/i.test(txt(l));
    })[0];
    if (!fs || fs.querySelector('.sww-sc-link') || vitalsShowing(info)) return;
    var desc = document.querySelector('.product__description');
    if (!desc) return;
    var table = [].slice.call(desc.querySelectorAll('table')).filter(function (t) {
      var s = txt(t);
      return /(typical|example) breeds/i.test(s) && /\b(xs|s|m|l|xl|2xl|small|medium|large)\b/i.test(s);
    })[0];
    if (!table) return;

    var dlg = document.createElement('dialog');
    dlg.className = 'sww-sc-dialog';
    dlg.setAttribute('aria-labelledby', 'sww-sc-title');
    dlg.innerHTML = '<div class="sww-sc-head"><h2 id="sww-sc-title">Size chart</h2><button type="button" class="sww-sc-close" aria-label="Close size chart">&times;</button></div><div class="sww-sc-body"><div class="sww-sc-scroll"></div></div>';
    var body = dlg.querySelector('.sww-sc-body');
    var scroll = dlg.querySelector('.sww-sc-scroll');
    /* keep the table in the description and show a clean copy in the pop-up */
    var copy = table.cloneNode(true);
    [copy].concat([].slice.call(copy.querySelectorAll('*'))).forEach(function (e) {
      ['style', 'class', 'width', 'bgcolor'].forEach(function (a) { e.removeAttribute(a); });
    });
    scroll.appendChild(copy);
    var note = document.createElement('p');
    note.className = 'sww-sc-note';
    note.textContent = 'Breeds are a guide only, as dogs vary. Measure your dog and compare with the table. If your dog is between two sizes, choose the larger one.';
    body.appendChild(note);
    document.body.appendChild(dlg);

    /* let the breed names wrap so nobody has to scroll sideways to read them */
    var st = document.createElement('style');
    st.textContent = '.sww-sc-dialog .sww-sc-scroll table{width:100% !important}.sww-sc-dialog .sww-sc-scroll td:last-child,.sww-sc-dialog .sww-sc-scroll th:last-child{white-space:normal !important;text-align:left !important;min-width:150px;line-height:1.4}.sww-sc-dialog .sww-sc-scroll td,.sww-sc-dialog .sww-sc-scroll th{vertical-align:top}';
    document.head.appendChild(st);

    function open(e) {
      if (e) e.preventDefault();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    }
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    dlg.querySelector('.sww-sc-close').addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });

    var link = document.createElement('button');
    link.type = 'button';
    link.className = 'sww-sc-link';
    link.innerHTML = RULER + '<span>Size chart</span>';
    link.addEventListener('click', open);
    var legend = fs.querySelector('.product__option-label');
    legend.classList.add('sww-has-sc');
    legend.appendChild(link);

    /* if a Vitals size chart button turns up later, keep only one */
    function dedupe() { if (vitalsShowing(info)) link.style.display = 'none'; }
    if (window.MutationObserver) {
      var mo = new MutationObserver(dedupe);
      mo.observe(info, { childList: true, subtree: true });
      setTimeout(function () { mo.disconnect(); }, 15000);
    }
    dedupe();
  }

  function start() {
    setTimeout(function () { try { build(); } catch (e) {} }, 1500);
    setTimeout(function () { try { build(); } catch (e) {} }, 4000);
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
})();
